import React from 'react'
import { browserHistory } from 'browser/history'
import { Button } from 'browser/components/atomic-elements/atoms/button/button'

import './_back-button.scss'

/**
 * @uiComponent
 *
 * Mobile-web generic back action. Returns to the previous screen by default, or
 * — when `backTo` is supplied — navigates to that path (e.g.
 * "/assignments-and-check-ins" to return home).
 */
interface IBackButtonProps {
  buttonText?: string
  /** Optional path to navigate to instead of going back one entry. */
  backTo?: string
}

export class BackButton extends React.PureComponent<IBackButtonProps> {
  static defaultProps = {
    buttonText: 'Back',
  }

  public render() {
    return (
      <div className="back-button">
        <Button
          className="back-button__btn"
          buttonText={this.props.buttonText}
          onClick={this.handleClick}
        />
      </div>
    )
  }

  private handleClick = () => {
    const { backTo } = this.props
    if (backTo) {
      browserHistory.push(backTo)
    } else {
      browserHistory.goBack()
    }
  }
}
